<template>
	<BackButton :text="t('back_button.overview')" link="Home"></BackButton>
	<!-- <InfoButton @click="showOverlay" /> -->
	<div v-if="te('timeline')" class="container-fluid px-0 h-100 w-100">
		<!-- <h3 class="text-center museum-titel-test">Tijdlijn Gemeente Harenkarspel</h3> -->
		<div id="myCarousel" class="carousel slide" data-bs-touch="true" data-bs-ride="carousel" data-bs-interval="false">
			<div class="carousel-inner timeline-display" role="listbox">
				<div class="carousel-item" :class="{active: index === LastActiveItem }" v-for="(timeline, index) in tm(`timeline.timeline`)" :key="timeline">
					<div class="d-flex align-items-center justify-content-center min-vh-100">
						<div class="col mx-5" style="margin-top: -75px;" v-for="(content, contentIndex) in tm(`timeline.timeline[${index}].content`)" :key="content">
							<TextComponent v-if="t(`timeline.timeline[${index}].content[${contentIndex}].acf_fc_layout`) == 'textfield'" :text="t(`timeline.timeline[${index}].content[${contentIndex}].tekst`)" />
							<ImageComponent v-if="t(`timeline.timeline[${index}].content[${contentIndex}].acf_fc_layout`) == 'image'" :url="t(`timeline.timeline[${index}].content[${contentIndex}].image`)" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="gallery-btn gallery-left-btn galerij-prev-btn" @click="previousYear">
			<img draggable="false" class="gallery-btn-img" src="~@/assets/img/prev.svg" />
		</div>
		<div class="gallery-btn gallery-right-btn galerij-next-btn" @click="nextYear">
			<img draggable="false" class="gallery-btn-img" src="~@/assets/img/next.svg" />
		</div>
		<div id="timeline" class="timeline">
			<div class="year" :class="{active: index === CurrentItem}" v-for="(timeline, index) in tm(`timeline.timeline`)" @click="changeYear(index, $event)" :key="timeline" :data-year="timeline.year"><div @click="changeYear(index, $event)" class="year-click"></div></div>
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Carousel } from "bootstrap";
import TextComponent from "@/components/timeline/Text.vue";
import ImageComponent from "@/components/timeline/Image.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import InfoButton from "@/components/buttons/InfoButton.vue";

export default {
	name: "Timeline",
	components: {
		TextComponent,
		ImageComponent,
		BackButton,
		InfoButton,
	},
	setup() {
		const { t, te, tm } = useI18n();

		return { t, te, tm };
	},
	data() {
		return {
			CurrentItem: 0,
			LastActiveItem: 0,
			TotalItems: 1,
			Carousel: null,
			Sliding: false,
			CurrentLocale: this.$i18n.locale,
		};
	},
	mounted() {
		// Might be a better way of doing it like this :)
		const { tm } = useI18n();

		this.TotalItems = tm(`timeline.timeline`).length;

		this.Carousel = new Carousel(document.getElementById("myCarousel"));

		// Setup slide events
		document.getElementById("myCarousel").addEventListener("slide.bs.carousel", this.startSlide);
		document.getElementById("myCarousel").addEventListener("slid.bs.carousel", this.endSlide);

		this.setupTimeLine();
	},
	beforeUpdate() {
		if(this.CurrentLocale != this.$i18n.locale)
		{
			this.LastActiveItem = this.CurrentItem;
		}
	},
	updated() {
		if(this.CurrentLocale != this.$i18n.locale)
		{
			this.CurrentLocale = this.$i18n.locale; 
			this.setupTimeLine();
		}
	},
	methods: {
		setupTimeLine() {
			// Get all the years
			let years = document.getElementsByClassName("year");

			console.log(years.length + " aantal jaren");

			if (years.length > 0) {
				let startYear = years[0].getAttribute("data-year");
				let endYear = years[years.length - 1].getAttribute("data-year");

				let yearDifference = endYear - startYear;

				let segments = years.length - 1;

				let leftOffset = 100 / segments;

				let leftOffsetPercentage = leftOffset;

				// Loop though all the year elements, except the first and the last one
				for (let i = 1; i < years.length - 1; i++) {
					let year = years[i].getAttribute("data-year");

					years[i].style.left = `${leftOffsetPercentage}%`;

					leftOffsetPercentage += leftOffset;
				}
			}
		},
		changeYear(number, event) {
			if (this.Carousel && !this.Sliding) {
				this.Carousel.to(number);
				this.CurrentItem = number;
			}
		},
		startSlide(event) {
			// Set sliding to true to prevent the user from screwing shit up :)
			this.Sliding = true;
			this.CurrentItem = event.to;
		},
		endSlide(event) {
			this.Sliding = false;
		},
		nextYear(event) {
			if (this.Carousel && !this.Sliding) {
				this.Carousel.next();
			}
		},
		previousYear(event) {
			if (this.Carousel && !this.Sliding) {
				this.Carousel.prev();
			}
		},
	},
};
</script>

<style scoped>
.timeline-display {
	padding-left: 100px;
	padding-right: 100px;
}

/* .timeline-display::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	width: 100px;
	background-image: linear-gradient(to right, rgba(243, 241, 237, 1), rgba(255, 0, 0, 0));
	bottom: 0;
	z-index: 1;
}

.timeline-display::after {
	content: "";
	position: absolute;
	right: 0;
	top: 0;
	width: 100px;
	background-image: linear-gradient(to left, rgba(243, 241, 237, 1), rgba(255, 0, 0, 0));
	bottom: 0;
	z-index: 1;
} */

.year-click {
	width: 100%;
	height: 100%;
}

.year-click::after {
	content: "";
	position: absolute;
	left: -25px;
	top: -30px;
	right: -25px;
	bottom: -70px;
}

.timeline {
	position: absolute;
	left: 120px;
	right: 120px;
	bottom: 204px;
	background-color: #707070;
	height: 2px;
	z-index: 2;
}

.timeline .year:first-child {
	--size: 36px;
	--offset: calc(var(--size) / 2 * -2 + var(--size) / 2);
	position: absolute;
	width: var(--size);
	height: var(--size);
	left: var(--offset);
	top: var(--offset);
	background-color: white;
	border: #af0909 2px solid;
	border-radius: 100%;
}

.timeline .year:first-child::after {
	position: absolute;
	content: attr(data-year);
	left: 0;
	right: 0;
	text-align: center;
	margin-left: -100%;
    margin-right: -100%;
	top: 30px;
	font-size: 30px;
	color: #fff;
}

.timeline .year:last-child {
	--size: 36px;
	--offset: calc(var(--size) / 2 * -2 + var(--size) / 2);
	position: absolute;
	width: var(--size);
	height: var(--size);
	right: var(--offset);
	top: var(--offset);
	background-color: white;
	border: #af0909 2px solid;
	border-radius: 100%;
}

.timeline .year:last-child::after {
	position: absolute;
	content: attr(data-year);
	text-align: center;
	margin-left: -100%;
    margin-right: -100%;
	left: 0;
	right: 0;
	top: 30px;
	font-size: 30px;
	color: #fff;
}

.timeline .year {
	--size: 22px;
	--offset: calc(var(--size) / 2 * -2 + var(--size) / 2);
	position: absolute;
	width: var(--size);
	height: var(--size);
	top: var(--offset);
	background-color: #fff;
	border-radius: 100%;
}

.timeline .year:not(:first-child):not(:last-child)::after {
	position: absolute;
	content: attr(data-year);
	left: -5px;
	top: 40px;
	font-size: 20px;
	transform: rotate(-90deg);
	color: #fff;
}

.timeline .year:first-child.active::before,
.timeline .year:last-child.active::before {
	position: absolute;
	content: "";
	background-image: url("~@/assets/img/icons/image-compare-button.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: 100px;
	width: 40px;
	left: -4px;
	top: -50px;
}

.timeline .year.active::before {
	position: absolute;
	content: "";
	background-image: url("~@/assets/img/icons/image-compare-button.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: 100px;
	width: 40px;
	left: -9px;
	top: -50px;
}

.timeline .year.active::after,
.timeline .year.active:not(:first-child):not(:last-child)::after {
	position: absolute;
	content: attr(data-year);
	text-align: center;
	margin-left: -100%;
    margin-right: -100%;
	top: 40px;
	font-size: 50px;
	transform: rotate(0deg);
}

.gallery-btn {
	position: absolute;
	background-color: #1f1f1f;
	width: 99px;
	height: 99px;
	z-index: 2;
}

.gallery-left-btn {
	left: 0;
	top: calc(50% - var(--global-footer-height));
}

.gallery-right-btn {
	right: 0;
	top: calc(50% - var(--global-footer-height));
}

.gallery-close-btn {
	right: 0;
	top: 0;
}

.gallery-btn-img {
	position: absolute;
	height: 67px;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
}
</style>